var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 448 448"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,13.5l-59.7,343.5l-208.4,74.7L0,356.9l18.3-88.5h76.5l-7.5,37.9L196,347.8l125.2-41.4l17.5-90.6H27.5 l14.9-76.5h311.5l9.8-49.2H52.5l15.2-76.5L448,13.5L448,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss2);
export default __webpack_public_path__ + "static/media/css2.2d0f98d219ae59d09d28f91dfd5ef6ab.svg";
export { ForwardRef as ReactComponent };